export default __webpack_public_path__ + "static/media/art.acb4ec38.jpg";